export default function extractNameFromEmail(email) {
  if (!email.includes("@")) {
    return "";
  }
  return email.split("@")[0];
}
